<template>
  <div id="stdapplinf">
    <stdapplinf-detail  :labels="labels[app.nowLang]"
                        :data="index"
                        :columns="columns[app.nowLang]"
                        :dataTappoinf="dataTappoinf"
                        :receivedStdapplinfTappoinf="receivedStdapplinfTappoinf" />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/stdapplinf/mutation-types'
import stdapplinfDetail from 'components/stdapplinf/stdapplinfDetail'

export default {
  name: 'stdapplinf',
  data () {
    return {
      app: this.$root.$children[0],
      searchParams: {
        numappl: ''
      }
    }
  },
  created () {
    this.receivedStdapplinfColumnsLabels()
  },
  computed: {
    ...mapGetters({
      indexDisp: types.GET_STDAPPLINF_INDEX_DISP,
      columns: types.GET_STDAPPLINF_COLUMNS,
      labels: types.GET_STDAPPLINF_LABELS,
      index: types.GET_STDAPPLINF_INDEX,
      dataTappoinf: types.GET_STDAPPLINF_TAPPOINF
    })
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      toggle: types.TOGGLE_STDAPPLINF_PAGE,
      receivedStdapplinfColumnsLabels: types.RECEIVED_STDAPPLINF_COLUMNS_LABELS,
      receivedStdapplinfIndex: types.RECEIVED_STDAPPLINF_INDEX,
      receivedStdapplinfTappoinf: types.RECEIVED_STDAPPLINF_TAPPOINF
    })
  },
  components: {
    stdapplinfDetail
  }
}
</script>




// WEBPACK FOOTER //
// component.vue?d2e19a22